var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5878 2.19028C19.4732 1.76862 19.2502 1.38427 18.941 1.0754C18.6318 0.766523 18.2472 0.54387 17.8253 0.429544C16.2601 0 9.99996 0 9.99996 0C9.99996 0 3.73944 0 2.1746 0.411971C1.75286 0.532361 1.36919 0.759171 1.06046 1.0706C0.751733 1.38203 0.528328 1.76761 0.411717 2.19028C0 3.75499 0 6.99922 0 6.99922C0 6.99922 0 10.2602 0.411717 11.8082C0.526265 12.2301 0.749237 12.6147 1.05849 12.9239C1.36774 13.233 1.75252 13.4559 2.1746 13.5705C3.75623 14 9.99996 14 9.99996 14C9.99996 14 16.2601 14 17.8253 13.5884C18.2474 13.474 18.6322 13.2511 18.9415 12.9419C19.2508 12.6328 19.4737 12.2481 19.5882 11.8261C19.9999 10.2602 19.9999 7.01562 19.9999 7.01562C19.9999 7.01562 20.0163 3.75499 19.5878 2.19028ZM8.00778 9.99665V4.00179L13.2136 6.99922L8.00778 9.99665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.408887f2cbefd1f56c435d70a2682e5e.svg";
export { ForwardRef as ReactComponent };